// extracted by mini-css-extract-plugin
module.exports = {"title":"_ade83ff","primary":"_1f66bc8","secondary":"_53ae696","tertiary":"_2f66fcd"};